import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';
import { HOME_PAGE_URL } from '../constants/systemConstants';

const PublicRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <LoadingSpinner 
        fullPage 
        size={40}
        text="Loading..."
      />
    );
  }

  if (currentUser) {
    const from = location?.state?.from?.pathname || HOME_PAGE_URL;
    return <Navigate to={from} replace />;
  }

  return children;
};

export default PublicRoute;